export const API_OPTIONS = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwMzk5MWYwYWNhYzUxZWY1YTlmOGMzM2RjYjJjMjk0OSIsInN1YiI6IjY0NmM1MmQ3YzM1MTRjMmIwODUxY2Q0MyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.SXR5cXinm_1CnLiPncgZwibo0YH8laUFRDfm_XSgRDQ",
  },
};

export const IMG_URL = "https://image.tmdb.org/t/p/w500";

export const OPENAI_API_KEY =
  "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";
